module.exports = __webpack_public_path__ + "img/4E4D40_979786_AEAEA1_878678-256px.424f252a.png";